import { render, staticRenderFns } from "./OtherGemstoneReport1920.vue?vue&type=template&id=f4577aa4&scoped=true"
import script from "./OtherGemstoneReport1920.vue?vue&type=script&lang=js"
export * from "./OtherGemstoneReport1920.vue?vue&type=script&lang=js"
import style0 from "./OtherGemstoneReport1920.vue?vue&type=style&index=0&id=f4577aa4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4577aa4",
  null
  
)

export default component.exports